import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { onboardingSelector } from '../../../reducers/onboarding';
import { apiRequest } from '../../../APIClient';

// on mount, fetch contact section once if it hasn't been fetched before
export const useFetchContactSection = () => {
  const hasFetched = useSelector(onboardingSelector.hasFetchedContactSection);

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!hasFetched) {
      dispatch(apiRequest.getOBContacts());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
};
